import { useMedia } from 'react-use'

import { BREAKPOINT_DIMENSIONS } from '@/lib/constants'
import { Breakpoint } from '@/types/misc'

function useMinWidth(breakpoint: Breakpoint) {
  return useMedia(`(min-width: ${BREAKPOINT_DIMENSIONS[breakpoint]}px)`)
}

export default useMinWidth
